<template>
  <div>
    <Header> </Header>

    <PageContainer>
      <div class="gap-row-sm">
        <div class="iqos-grid">
          <div class="iqos-column" style="height: 100%">
            <CurrentBalance style="height: 100%"/>
          </div>
          <div class="iqos-column" style="height: 100%">
            <OutcomeStats style="height: 100%"/>
          </div>
        </div>

        <div class="gap-row-xs">
            <div class="gap-column-xs short-table-header">
                <div class="qrw-heading-xs bold v1-grey-10-color w-100">
                    {{ $t('balance_table.recent') }}
                </div>
                <BaseButton icon="timer" @click="$router.push('/balance/table')" size="md" variant="secondary" color="v1-grey-10" class="nowrap">
                    {{ $t('balance_table.btn_see_all')}}
                </BaseButton>
            </div>

          <BalanceTransactionsTable
            :transactions="transactions"
            :compact="true"
          />
        </div>
      </div>
    </PageContainer>
  </div>
</template>

<style scoped>
.short-table-header {
    align-items: center;
}
</style>

<script>
import CurrentBalance from "@/components/balance/BalancePanel.vue";
import BalanceTransactionsTable from "@/components/balance/BalanceTransactionsTable.vue";
import OutcomeStats from "@/components/balance/OutcomeStats.vue"

import BillingAPI from "@/api/billing";

export default {
  components: {
    CurrentBalance,
    BalanceTransactionsTable,
    OutcomeStats
  },
  data() {
    return {
      transactions: [],
    };
  },
  methods: {
    fetchData() {
      BillingAPI.getTransactions(9)
        .then((data) => {
          this.transactions = data.transactions;
        })
        .catch((err) => {});
    },
  },
  computed: {

  },
  mounted() {
    this.fetchData();
  },
};
</script>
